import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { User } from '../../../pages/Dashboard/Dashboard';
import { BsBuilding } from 'react-icons/bs';
import {
  FaEye,
  FaStar,
  FaExclamationTriangle,
  FaRupeeSign,
  FaHome,
  FaExclamationCircle,
  FaHeadset,
} from 'react-icons/fa';
import { FaDollarSign } from 'react-icons/fa6';
import './StatsSectionComponent.scss';
import userone from '../../../assets/images/avatar.png';
import { formatDate } from '../../../utils/formatDateTimeForMessage';
import axios from 'axios';
import { getAllDashboardNotification } from '../../../utils/APIRoutes';
import { usePermissions } from '../../../utils/Permission/Permission';
import Loader from '../../CommonComponents/Loader/Loader';
import { ToastType, showToastMessage } from '../../../utils/ToastOptionCommon';
import axiosCall from '../../../utils/axiosCall';
import { useSocket } from '../../../context/SocketProvider';
import { useNavigate } from 'react-router';
import { AppDispatch } from '../../../redux/store';
import { activeUsers, setChatData } from '../../../redux/slices/ChatSlice';
import BarChart from '../../../utils/Charts/BarChart/BarChart';
import {
  BarChartOption,
  DashboardAdminConfig,
  DashboardOwnerConfig,
} from '../../../utils/Charts/BarChart/BarChartOption';
import { USDateFormat } from '../../../utils/common';
import { loggedInUserState } from '../../../redux/slices/LoginSlice';

type propCard = {
  title: string;
  value?: number | string;
  icon: JSX.Element;
  isVisible: boolean;
  clickableLink?: boolean;
  link?: string;
  data?: any;
};

function StatsSectionComponent(props: any) {
  const { hasPermission } = usePermissions();
  const [allPropertiesCount, setAllPropertiesCount] = useState(0);
  const [totalTenants, setTotalTenants] = useState(0);
  const [totalOwners, setTotalOwners] = useState(0);
  const [totalFavourites, setTotalFavourites] = useState(0);
  const [topFavourites, setTopFavourites] = useState([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isOwnerVerified, setIsOwnerVerified] = useState(false);
  const [pendingPropertiesCount, setPendingPropertiesCount] = useState(0);
  const onlineUsers = useSelector(activeUsers);
  const propCardsData: propCard[] = [
    {
      title: 'All Properties',
      value: allPropertiesCount,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#848BFF] from-[#3640E1]">
          <BsBuilding className="icon-color" />
        </div>
      ),
      isVisible: hasPermission('admin.owner'),
      link: '/dashboard/listing',
      data: { initialStatusFilter: undefined },
    },
    // {
    //   title: 'Rented Properties',
    //   value: totalIncome,
    //   icon: (
    //     <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
    //       <FaRupeeSign className="icon-color" />
    //     </div>
    //   ),
    //   isVisible: hasPermission('owner'),
    // },
    {
      title: 'Inactive Properties',
      value: pendingPropertiesCount,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FF9663] from-[#FA702C]">
          <FaExclamationTriangle className="icon-color red" />
        </div>
      ),
      isVisible: hasPermission('owner'),
      data: { initialStatusFilter: false },
    },
    // {
    //   title: 'Total Views',
    //   value: 0,
    //   icon: (
    //     <div className="p-2 rounded-full bg-gradient-to-tl to-[#FF9663] from-[#FA702C]">
    //       <FaEye className="icon-color blue" />
    //     </div>
    //   ),
    //   isVisible: hasPermission('owner'),
    // },
    {
      title: 'Total Owners',
      value: totalOwners,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FF9663] from-[#FA702C]">
          <FaEye className="text-white" />
        </div>
      ),
      isVisible: hasPermission('admin'),
    },
    {
      title: 'Total Tenants',
      value: totalTenants,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FF9663] from-[#FA702C]">
          <FaEye className="text-white" />
        </div>
      ),
      isVisible: hasPermission('admin'),
    },
    {
      title: 'Total Favorites',
      value: totalFavourites,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
          <FaEye className="icon-color blue" />
        </div>
      ),
      isVisible: hasPermission('tenant'),
    },
    // {
    //   title: 'Calculator',
    //   icon: (
    //     <div className="p-2 rounded-full bg-gradient-to-tl to-[#FF9663] from-[#FA702C]">
    //       <FaEye className="text-white" />
    //     </div>
    //   ),
    //   isVisible: hasPermission('tenant'),
    // },
    // {
    //   title: 'Veriafied Link',
    //   icon: (
    //     <div className="p-2 rounded-full bg-gradient-to-tl to-[#86FFB6] from-[#2DCF6D]">
    //       <FaStar className="text-white" />
    //     </div>
    //   ),
    //   isVisible: hasPermission('owner'),
    // },
    {
      title: 'Total Income',
      value: totalIncome,
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
          <FaDollarSign className="icon-color" />
        </div>
      ),
      isVisible: hasPermission('admin'),
    },
    {
      title: 'Verification Status',
      value: isOwnerVerified ? 'Verified' : 'Not Verified',
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
          {isOwnerVerified ? (
            <span className="verified-badge" title="Verified Owner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="green"
              >
                <path d="m352.46-85.39-71.38-120.3-135.54-29.7 13.23-139.53L66.93-480l91.84-105.08-13.23-139.53 135.54-29.7 71.38-120.3L480-820.46l127.54-54.15 71.38 120.3 135.54 29.7-13.23 139.53L893.07-480l-91.84 105.08 13.23 139.53-135.54 29.7-71.38 120.3L480-139.54 352.46-85.39ZM378-162l102-43.23L583.23-162 640-258l110-25.23L740-396l74-84-74-85.23L750-678l-110-24-58-96-102 43.23L376.77-798 320-702l-110 24 10 112.77L146-480l74 84-10 114 110 24 58 96Zm102-318Zm-42 128.15L650.15-564 608-607.38l-170 170-86-84.77L309.85-480 438-351.85Z" />
              </svg>
            </span>
          ) : (
            <span className="verified-badge" title="Unverified Owner">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 -960 960 960"
                width="24px"
                fill="red"
              >
                <path d="m352.46-85.39-71.38-120.3-135.54-29.7 13.23-139.53L66.93-480l91.84-105.08-13.23-139.53 135.54-29.7 71.38-120.3L480-820.46l127.54-54.15 71.38 120.3 135.54 29.7-13.23 139.53L893.07-480l-91.84 105.08 13.23 139.53-135.54 29.7-71.38 120.3L480-139.54 352.46-85.39ZM378-162l102-43.23L583.23-162 640-258l110-25.23L740-396l74-84-74-85.23L750-678l-110-24-58-96-102 43.23L376.77-798 320-702l-110 24 10 112.77L146-480l74 84-10 114 110 24 58 96Zm102-318Zm-42 128.15L650.15-564 608-607.38l-170 170-86-84.77L309.85-480 438-351.85Z M672-240 240-672l33-33 432 432-33 33Z" />
              </svg>
            </span>
          )}
        </div>
      ),
      isVisible: hasPermission('owner.tenant'),
      clickableLink: true,
    },
    {
      title: 'Housing Inquiry',
      value: 'Click here to redirect to Housing Inquiry',
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
          <FaHome className="icon-color" />
        </div>
      ),
      isVisible: hasPermission('tenant'),
      clickableLink: true,
      link: '/housing-inquiry',
    },
    {
      title: 'Customer Support',
      value: 'Didn’t find what you’re looking for? Contact us.',
      icon: (
        <div className="p-2 rounded-full bg-gradient-to-tl to-[#FFA2B8] from-[#FB517A]">
          <FaHeadset className="icon-color" />
        </div>
      ),
      isVisible: hasPermission('owner.tenant'),
      clickableLink: true,
      link: '/contact-us',
    },
  ];

  const userData: User = useSelector(loggedInUserState);

  const socket = useSocket();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [messageNotification, setMessageNotification] = useState<any>();
  const [AllNotification, setAllNotification] = useState<any>([]);
  const [refreshNotificaion, setRefreshNotificaion] = useState(false);
  const [chartLoading, setChartLoading] = useState(false);
  const [chartData, setChartData] = useState<any>(DashboardAdminConfig.data);
  const [chartOptions, setChartOptions] = useState<any>(
    DashboardAdminConfig.options
  );

  const openLink = (data?: any) => {
    navigate(`/dashboard/listing`, {
      state: data,
    });
  };

  useEffect(() => {
    if (userData?.currentRole?.toLowerCase() === 'admin') {
      setChartOptions(DashboardAdminConfig.options);
    } else if (userData?.currentRole?.toLowerCase() === 'owner') {
      setChartOptions(DashboardOwnerConfig.options);
    }
  }, []);

  // fetch dashboard stats
  useEffect(() => {
    (async () => {
      let url = 'dashboard/data';
      try {
        setIsLoading(true);
        const result = await axiosCall.get(url);
        // console.log(result.data);
        setAllPropertiesCount(() => result.data.userPropertyCount);
        setIsOwnerVerified(() => result.data.isOwnerVerified);
        setPendingPropertiesCount(() => result.data.pendingPropertiesCount);

        // console.log(userData);
        if (userData.role.includes('Admin')) {
          setTotalOwners(() => result.data.ownersCount);
          setTotalTenants(() => result.data.tenantsCount);
          setTotalIncome(() => result.data.totalIncome);
        }
        if (userData.role.includes('Tenant')) {
          setTotalFavourites(() => result.data.totalFavourites);
          setTopFavourites(() => result.data.topFavourites);
        }
      } catch (error) {
        showToastMessage("Can't fetch data", ToastType.Error);
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const convertToUTC = (yearMonthString: string): number => {
    const [year, month] = yearMonthString.split('-').map(Number);
    return Date.UTC(year, month - 1, 1); // Set day to 1 to represent the start of the month
  };

  const getChartData = async () => {
    try {
      setChartLoading(true);
      const data = {
        role: userData.currentRole,
      };
      const response = await axiosCall.post('/dashboard/chart-data', data);
      if (userData?.currentRole?.toLowerCase() === 'admin') {
        const propertiesData = response.data?.properties?.map(
          (item: any) => item.count
        );
        const subscriptionData = response.data?.subscription?.map(
          (item: any) => item.amount
        );
        const labels = response.data?.properties?.map((item: any) =>
          new Date(item.date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
          })
        );

        setChartData({
          ...DashboardAdminConfig.data,
          labels,
          datasets: [
            { ...DashboardAdminConfig.data.datasets[0], data: propertiesData },
            {
              ...DashboardAdminConfig.data.datasets[1],
              data: subscriptionData,
            },
          ],
        });

        setChartOptions(DashboardAdminConfig.options);
      } else if (userData?.currentRole?.toLowerCase() === 'owner') {
        const rentProperties =
          response.data?.properties?.flatMap(
            (month: any) => month.properties
          ) || [];

        const sellProperties =
          response.data?.sellListings?.flatMap(
            (month: any) => month.properties
          ) || [];

        const allProperties = [
          ...rentProperties.map((p: any) => ({
            title: `🏠 ${p.title}`,
            views: p.views,
          })),
          ...sellProperties.map((p: any) => ({
            title: `💰 ${p.title}`,
            views: p.views,
          })),
        ];

        setChartData({
          ...DashboardOwnerConfig.data,
          labels: allProperties.map((p: any) => p.title),
          datasets: [
            {
              label: 'Property Views',
              data: allProperties.map((p: any) => p.views || 0),
              backgroundColor: 'rgba(54, 162, 235, 0.6)',
              borderColor: 'rgba(54, 162, 235, 0.6)',
              borderWidth: 1,
              borderRadius: 6,
            },
          ],
        });

        setChartOptions(DashboardOwnerConfig.options);
      }
    } catch (error) {
      showToastMessage('Failed to get chart data', ToastType.Error);
    } finally {
      setChartLoading(false);
    }
  };

  useEffect(() => {
    if (userData?.currentRole?.toLowerCase() !== 'tenant') {
      getChartData();
    }
  }, [userData?.currentRole]);

  const markContactActive = (cntct: Array<any>) => {
    if (cntct?.length) {
      let ctc = [...cntct];
      ctc.forEach((e: any) => {
        if (onlineUsers.includes(e?.lastMessage?.users?.from?._id)) {
          e.lastMessage.users.from.active = true;
        } else {
          e.lastMessage.users.from.active = false;
        }
      });
      return ctc;
    }
    return cntct;
  };

  useEffect(() => {
    if (AllNotification?.length) {
      setAllNotification(markContactActive(AllNotification));
    }
  }, [onlineUsers]);

  // fetch all messages
  useEffect(() => {
    const fetchAllMessages = async () => {
      const response = await axios.get(
        `${getAllDashboardNotification}/${userData?._id}`
      );
      if (response.data) {
        setAllNotification(markContactActive(response?.data?.message));
      }
      // console.log("------->>",response.data)
    };
    fetchAllMessages();
  }, []); // eslint-disable-line

  useEffect(() => {
    socket.on('receiver-notifications', (res: any) => {
      setAllNotification(res?.message);
    });

    return () => {
      socket.off('receiver-notifications');
    };
  }, [socket]);

  const handleViewChat = async (chatId: string, item: any, active: boolean) => {
    navigate('/dashboard/message');
    item.active = active;
    dispatch(setChatData({ chatId, data: item }));
    // socket.io send msg
    // socket.emit('mark-as-read', {
    //   senderId,
    //   UserId,
    // });
    // console.log( senderId, UserId)
    // setRefreshNotificaion((prevTrigger) => !prevTrigger);
  };

  const title =
    userData?.currentRole?.toLowerCase() === 'admin'
      ? 'Property & Subscription'
      : 'Property & Views';

  const gotoPropertyDetail = (id: string) => {
    navigate(`/property-detail/${id}`);
  };

  return (
    <div className="d-flex flex-column dashboard-tiles">
      {isLoading && <Loader />}

      {/* <div className="earning-overview"> */}
      <div className="row order-md-1 order-2">
        {propCardsData?.map(
          (data, index) =>
            data.isVisible && (
              <div key={index} className="col-sm-6 col-xl-3 mb-0 mb-sm-4">
                <div className="box-view h-100">
                  {/* <div className="d-flex"> */}
                  <div className="text-center">
                    <div className="d-flex align-items-center justify-content-center mb-3">
                      {data.icon}
                      <h5 className="m-0">{data.title}</h5>
                    </div>
                    {!data.clickableLink ? (
                      <h2 onClick={() => openLink(data.data)} className="cp">
                        {data.title === 'Total Income'
                          ? data.value?.toLocaleString('en-IN', {
                              currency: 'INR',
                              style: 'currency',
                              maximumFractionDigits: 0,
                            })
                          : data.title === 'Total Views'
                            ? data.value?.toLocaleString('en-IN', {
                                currency: 'INR',
                                maximumFractionDigits: 0,
                              })
                            : data.value}
                      </h2>
                    ) : (
                      <a href={data.link} target="_blank">
                        {data.value}
                      </a>
                    )}
                  </div>
                  {/* <div className="ms-auto">{data.icon}</div> */}
                  {/* </div> */}
                </div>
              </div>
            )
        )}
      </div>
      {/* </div> */}

      <div className="row order-md-2 order-1">
        {hasPermission('admin.owner') ? (
          <BarChart
            isLoading={chartLoading}
            data={chartData}
            options={chartOptions}
            title={title}
          />
        ) : (
          <div className="col-md-8 order-md-1 order-2">
            <div className="box-view h-100">
              <h3 className="box-title">Favorites Properties</h3>
              <div className="table-responsive">
                <table
                  className="table table-hover"
                  style={{ minWidth: 'auto' }}
                >
                  <thead>
                    <tr>
                      <th className="bg-white">Property</th>
                      <th className="bg-white">Property Type</th>
                      <th className="bg-white">Price</th>
                      <th className="bg-white">Available</th>
                    </tr>
                  </thead>
                  <tbody>
                    {topFavourites?.map((item: any, index: number) => {
                      return (
                        <tr
                          key={item?._id}
                          onClick={() => gotoPropertyDetail(item?._id)}
                        >
                          <td>
                            <div className="d-flex align-items-center">
                              <div className="property-listing-preview">
                                <img
                                  src={item?.imagesLink?.[0]}
                                  alt="property-listing-preview"
                                  className="img-fluid"
                                />
                              </div>
                              <div className="property-details ms-2">
                                <h5>{item?.title}</h5>
                                <p>{item?.description}</p>
                              </div>
                            </div>
                          </td>
                          <td className=" text-capitalize">{item?.p_type}</td>
                          <td>{item?.rooms?.[0].price}</td>
                          <td>
                            {USDateFormat(item?.rooms?.[0]?.availableFrom)}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        <div id="message-section" className="col-md-4 order-md-2 order-1">
          <div className="box-view h-100">
            <h3 className="box-title">Messages</h3>
            {AllNotification?.length < 1 ? (
              <div className="no-msg">No message received.</div>
            ) : (
              <></>
            )}
            <div className="messages">
              {AllNotification?.map((item: any) => {
                const name = `${item?.lastMessage?.users?.from?.firstName} ${item?.lastMessage?.users?.from?.lastName}`;
                const activeStatus =
                  item?.lastMessage?.users?.from?.active ?? false;
                return (
                  <div
                    key={item?.chatId?._id}
                    className="messages-user d-flex align-items-center"
                    onClick={() =>
                      handleViewChat(item?.chatId?._id, item, activeStatus)
                    }
                  >
                    <div className="user-img">
                      <img
                        src={
                          item?.lastMessage?.profilePic?.length
                            ? item?.lastMessage?.profilePic
                            : userone
                        }
                        className="img-fluid w-100"
                        alt={`${name}_pic`}
                      />
                      <span
                        className={`user-status user-auto-status ${
                          activeStatus ? 'live-status' : 'busy-status'
                        }`}
                      ></span>
                    </div>
                    <div className="user-details ms-3">
                      <a>
                        <h4 className="user-name mb-0">{name}</h4>
                        <div className="message-excerpt">
                          {(item?.lastMessage?.message &&
                            item?.lastMessage?.message.length) > 30
                            ? item?.lastMessage?.message?.slice(0, 30) + '...'
                            : item?.lastMessage?.message}
                          <br></br>
                          <span className="message-date-time">
                            {formatDate(item?.lastMessage?.date)}
                          </span>
                        </div>
                      </a>
                    </div>
                    <span className="message-count">
                      {item?.notification > 9 ? (
                        <>
                          {' '}
                          9 <span className="plus-icon">+</span>
                        </>
                      ) : (
                        item?.notification
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StatsSectionComponent;
